.g8{border:1px solid #ddd;}